import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { getAirQualityStationSelectOptions } from '../../utils/airQualityWidget.utils';

const airQualityStationSelectClassNames = {
  control: () => 'air-quality-station-select-control',
  valueContainer: () => 'air-quality-station-select-value',
  singleValue: () => 'air-quality-station-select-value-text',
  placeholder: () => 'air-quality-station-select-placeholder',
  indicatorsContainer: () => 'air-quality-station-select-indicators',
  dropdownIndicator: () => 'air-quality-station-select-dropdown-indicator',
  indicatorSeparator: () => 'air-quality-station-select-separator',
  menu: () => 'air-quality-station-select-menu',
  menuList: () => 'air-quality-station-select-menu-list',
  option: () => 'air-quality-station-select-option',
};

const AirQualityStationSelect = ({ stations = [], selectedStationName, onSelect }) => {
  const options = getAirQualityStationSelectOptions(stations);

  return (
    <BaseSelect
      wrapperClassName="air-quality-station-select"
      label="Air quality station"
      classNames={airQualityStationSelectClassNames}
      isSearchable
      selectProps={{
        options,
        value: findSelectOption(options, selectedStationName),
        isDisabled: options.length < 2,
        onChange: (option) => onSelect(option?.value ?? ''),
        placeholder: 'Select a station',
      }}
    />
  );
};

export default AirQualityStationSelect;
